<p>
  inductions-view works!
</p>
